import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  styles: [],
  template: `
    <block-ui>
      <router-outlet></router-outlet>
    </block-ui>
  `
})
export class AppComponent {

  constructor(translate: TranslateService) {
    
  }

}
